import { useDispatch } from "react-redux";
import { Productaction,Productcategoryaction } from "../../redux/productaction";
import { getproducts } from "../../redux/productslice";

const Product = ()=>{
   const dispatch = useDispatch();
   
   // const getproducts = ()=>{
   //    dispatch(Productaction())
   // }
 return(
    <>
   
    </>
 )
}

export default Product;